module.exports = __webpack_public_path__ + "bf8e82e5be4a0a319a59fac075b8ba8c.png";